module.exports = __webpack_public_path__ + "static/media/linkedin-logo-white.fb595be1.png";